// extracted by extract-css-chunks-webpack-plugin
module.exports = {"videoPlayBtn":"videoPlayBtn-2ksMjaaG","playingBtn":"playingBtn-xIsd1Fcr","pauseBtn":"pauseBtn-3S_EHpcK","replayBtn":"replayBtn-2gB-xG4H"};